import { CenterAlertApplication } from 'src/app/models/center-model/center-alert-application.model';
import { CenterAlertContact } from 'src/app/models/center-model/center-alert-contact.model';
import { CompanyMailConfig } from 'src/app/models/company-data-model/company-mail-config.model';
import { CenterAlertIotDevice } from './center-alert-iot-device.model';

export class CenterAlert {

    private active: boolean;
    private alertName: string;
    private centerAlertApplications: CenterAlertApplication[];
    private iotDevices: CenterAlertIotDevice[];
    private centerAlertCapacityList: any[];
    private centerAlertContacts: CenterAlertContact[];
    private centerAlertDeviceList: any[];
    private centerInternalId: string;
    private centerName: string;
    private companyMailConfig: CompanyMailConfig;
    private internalId: string;

    constructor(active?: boolean, alertName?: string, centerAlertApplications?: CenterAlertApplication[], iotDevices?: CenterAlertIotDevice[], centerAlertCapacityList?: any[], centerAlertContacts?: CenterAlertContact[], centerAlertDeviceList?: any[], centerInternalId?: string, centerName?: string, companyMailConfig?: CompanyMailConfig, internalId?: string) {
        this.active = active;
        this.alertName = alertName;
        this.centerAlertApplications = centerAlertApplications;
        this.iotDevices = iotDevices;
        this.centerAlertCapacityList = centerAlertCapacityList;
        this.centerAlertContacts = centerAlertContacts;
        this.centerAlertDeviceList = centerAlertDeviceList;
        this.centerInternalId = centerInternalId;
        this.centerName = centerName;
        this.companyMailConfig = companyMailConfig;
        this.internalId = internalId;
    }


    public get Active() {
        return this.active;
    }
    public get AlertName() {
        return this.alertName;
    }
    public get CenterAlertApplications() {
        return this.centerAlertApplications;
    }
    public get IotDevices() {
        return this.iotDevices;
    }
    public get CenterAlertCapacityList() {
        return this.centerAlertCapacityList;
    }
    public get CenterAlertContacts() {
        return this.centerAlertContacts;
    }
    public get CenterAlertDeviceList() {
        return this.centerAlertDeviceList;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get CompanyMailConfig() {
        return this.companyMailConfig;
    }
    public get InternalId() {
        return this.internalId;
    }

    public set Active(active) {
        this.active = active;
    }
    public set AlertName(alertName) {
        this.alertName = alertName;
    }
    public set CenterAlertApplications(centerAlertApplications) {
        this.centerAlertApplications = centerAlertApplications;
    }
    public set IotDevices(iotDevices) {
        this.iotDevices = iotDevices;
    }
    public set CenterAlertCapacityList(centerAlertCapacityList) {
        this.centerAlertCapacityList = centerAlertCapacityList;
    }
    public set CenterAlertContacts(centerAlertContacts) {
        this.centerAlertContacts = centerAlertContacts;
    }
    public set CenterAlertDeviceList(centerAlertDeviceList) {
        this.centerAlertDeviceList = centerAlertDeviceList;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set CompanyMailConfig(companyMailConfig) {
        this.companyMailConfig = companyMailConfig;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
}
